<template>
	<div :style="viewStyles">
		<div class="row justify-content-center">
			<div class="col-12 mb-4" :style="'padding-bottom: '+pb+'px'">
				<div ref="fixedContent" class="row justify-content-center fixed-wrapper">
					<div class="col-11 pt-3">
						<barcode-scanner @change="addToList" @resize="updateStyle"/>
						<hr>
					</div>
				</div>
			</div>
		</div>
		<div class="row justify-content-center">
			<div class="col-11">

				<p>Flaschen <span class="text-medium-gray">({{ activeBottles.length }})</span></p>
			</div>
		</div>
		<template v-for="(bottle, serial) in bottles">
			<scanner-list-item :key="serial"
			                   v-if="bottle || showDeleted"
			                   :bottle-no="serial"
			                   :highlights="false"
			>
				<template v-slot:default="{bottleNo}">
					<button
						class="btn btn-sm"
						@click="toggleBottle(bottleNo)"
					>
						<i v-if="bottle" class="fa fa-times"></i>
						<i v-else class="fa fa-trash-restore-alt"></i>
					</button>
				</template>

			</scanner-list-item>
		</template>

		<bottom-navigation @new-height="setBottomPadding">
			<template v-slot:left>
				<button class="btn btn-light btn-block" @click="$router.back()">
					{{ $t('Abbrechen') }}
				</button>
			</template>
			<template v-slot:right>
				<button :disabled="activeBottles.length === 0" class="btn btn-primary btn-block" @click="submitBottles">
					{{ $t('Fertig') }}
				</button>
			</template>
		</bottom-navigation>
	</div>
</template>

<script>
import Vue from 'vue'
import ScannerListItem from "../../components/ScannerListItem";
import BottomNavigation from "../../components/BottomNavigation";
import BarcodeScanner from "../../components/BarcodeScanner";
import allViews from "../../mixins/allViews";
import {mapActions, mapGetters, mapState} from "vuex";
import dayjs from "dayjs";

export default {
	name: "Scanner",
	components: {BarcodeScanner, ScannerListItem, BottomNavigation},
	mixins: [allViews],
	data() {
		return {
			bottles: {},
			showDeleted: false,
			pb: 0,
		}
	},
	computed: {
		...mapState({
			selectedDueDate: state => state.selectedDueDate,
			selectedBottleType: state => state.selectedBottleType,
		}),
		...mapGetters({
			findLatestActionId: "getLatestActionId"
		}),
		activeBottles() {
			return Object.keys(this.bottles).filter((el) => this.bottles[el])
		}
	},
	methods: {
		...mapActions({
			addBottlesToInventory: "Api/Bottles/entered_storage"
		}),
		updateStyle() {
			this.pb = this.$refs.fixedContent.clientHeight
		},
		addToList(serial) {
			if (!this.bottles[serial]) {
				console.log('add Bottle to list:', serial);
				Vue.set(this.bottles, serial, true);
			}
		},
		toggleBottle(serial) {
			Vue.set(this.bottles, serial, !this.bottles[serial]);
		},
		submitBottles() {
			if (this.activeBottles.length === 0) {
				return
			}
			let bottles = this.activeBottles.map(bottle_id => {
				return {
					"serial": bottle_id,
					"due": dayjs(this.selectedDueDate).startOf('day').format(this.$config.API_DATE_TIME_FORMAT),
					"type": this.selectedBottleType,
					"parent_id": this.findLatestActionId(bottle_id)
				}
			});

			this.addBottlesToInventory({bottles})
				.then(res => {
					if (res) {
						if (res.length === 1) {

							this.cdvAlert([this.$t('1 Flasche vom Typ'), this.selectedBottleType, this.$t('wurde zum Inventar hinzugefügt.')].join(' '));

						} else {
							this.cdvAlert([res.length, this.$t('Flaschen vom Typ'), this.selectedBottleType, this.$t('wurden zum Inventar hinzugefügt.')].join(' '));
						}
					}

					this.$router.push('/home').catch(() => null);
				})
				.catch(this.apiErrorHandler)
		}
	}
}
</script>
